/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { UiMenuDots3HIcon16Light } from './UiMenuDots3HIcon16Light';
import { UiMenuDots3HIcon16Regular } from './UiMenuDots3HIcon16Regular';
import { UiMenuDots3HIcon16Solid } from './UiMenuDots3HIcon16Solid';
import { UiMenuDots3HIcon20Light } from './UiMenuDots3HIcon20Light';
import { UiMenuDots3HIcon20Regular } from './UiMenuDots3HIcon20Regular';
import { UiMenuDots3HIcon20Solid } from './UiMenuDots3HIcon20Solid';
import { UiMenuDots3HIcon24Regular } from './UiMenuDots3HIcon24Regular';
import { UiMenuDots3HIcon24Solid } from './UiMenuDots3HIcon24Solid';
import { UiMenuDots3HIcon32Regular } from './UiMenuDots3HIcon32Regular';
import { UiMenuDots3HIcon64Regular } from './UiMenuDots3HIcon64Regular';
var sizes = {
    16: {
        light: UiMenuDots3HIcon16Light,
        regular: UiMenuDots3HIcon16Regular,
        solid: UiMenuDots3HIcon16Solid,
    },
    20: {
        light: UiMenuDots3HIcon20Light,
        regular: UiMenuDots3HIcon20Regular,
        solid: UiMenuDots3HIcon20Solid,
    },
    24: {
        regular: UiMenuDots3HIcon24Regular,
        solid: UiMenuDots3HIcon24Solid,
    },
    32: {
        regular: UiMenuDots3HIcon32Regular,
    },
    64: {
        regular: UiMenuDots3HIcon64Regular,
    },
};
export var UiMenuDots3HIcon = forwardRef('UiMenuDots3HIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
